var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Form/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Form = function (_React$Component) {
  (0, _inherits2.default)(Form, _React$Component);

  var _super = _createSuper(Form);

  function Form() {
    var _this;

    (0, _classCallCheck2.default)(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.generateKey = function (formItem, index) {
      return "form." + formItem + "_" + index;
    };

    return _this;
  }

  (0, _createClass2.default)(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          form = _this$props.form,
          headlineStyle = _this$props.headlineStyle,
          rowStyle = _this$props.rowStyle,
          formStyle = _this$props.formStyle,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["form", "headlineStyle", "rowStyle", "formStyle"]);
      if (!form || !form.length) return null;
      return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
        isFlex: true
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.Heading, (0, _extends2.default)({}, headlineStyle, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 17
        }
      }), headlineStyle.upperCase ? (0, _i18n.default)('form_title').toUpperCase() : (0, _i18n.default)('form_title')), _react.default.createElement(_Basic.Row, (0, _extends2.default)({}, rowStyle, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 17
        }
      }), _react.default.createElement(_Basic.Text, {
        grow: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 21
        }
      }, (0, _i18n.default)('form_label')), form.map(function (formItem, index) {
        return _react.default.createElement(_Basic.View, {
          key: _this2.generateKey(formItem, index),
          isFlex: true,
          height: formStyle.height,
          width: formStyle.width,
          bg: "form." + formItem,
          center: true,
          ml: 2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 25
          }
        }, _react.default.createElement(_Basic.Text, {
          color: "font.alternate",
          bold: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 60,
            columnNumber: 29
          }
        }, (0, _i18n.default)("form." + formItem)));
      })));
    }
  }]);
  return Form;
}(_react.default.Component);

Form.propTypes = {
  form: _propTypes.default.instanceOf(Array).isRequired,
  headlineStyle: _propTypes.default.object,
  rowStyle: _propTypes.default.object,
  formStyle: _propTypes.default.object
};
Form.defaultProps = {
  headlineStyle: {
    center: true,
    bold: true,
    size: 'large',
    py: 2
  },
  rowStyle: {
    borderX: 1,
    borderY: 1,
    borderColor: 'border.main',
    center: true,
    p: 2
  },
  formStyle: {
    height: 24,
    width: 24
  }
};
var _default = Form;
exports.default = _default;